import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './VKAccountSwitcher.css';

const VKAccountSwitcher = ({ show, onClose, onSwitch }) => {
    const [accounts, setAccounts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState(null);
    const [switchingAccountId, setSwitchingAccountId] = useState(null);

    useEffect(() => {
        if (show) {
            fetchAccounts();
        }
    }, [show]);

    const fetchAccounts = async () => {
        setLoading(true);
        setMessage(null);
        try {
            const response = await api.get('/vk-accounts/');
            setAccounts(Array.isArray(response.data) ? response.data : []);
        } catch (error) {
            console.error('Error fetching VK accounts for switcher:', error);
            setAccounts([]);
        } finally {
            setLoading(false);
        }
    };

    const handleSwitchAccount = async (accountId) => {
        setSwitchingAccountId(accountId);
        setMessage(null);
        try {
            await api.post(`/vk-accounts/${accountId}/switch`);
            setMessage({ type: 'success', text: 'Активный кабинет успешно изменен!' });
            // Trigger a full page reload to ensure all data is refreshed
            setTimeout(() => {
                if (onSwitch) {
                    onSwitch();
                } else {
                    window.location.reload();
                }
            }, 1000);
        } catch (error) {
            console.error('Error switching VK account:', error);
            const errorMsg = error.response?.data?.detail || 'Неизвестная ошибка при переключении кабинета.';
            setMessage({ type: 'error', text: errorMsg });
            setSwitchingAccountId(null);
        }
    };

    if (!show) {
        return null;
    }

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="vk-account-switcher-modal" onClick={(e) => e.stopPropagation()}>
                <div className="switcher-header">
                    <h2>Выберите VK Кабинет</h2>
                    <button className="close-btn" onClick={onClose}>×</button>
                </div>

                {message && (
                    <div className={`alert-box alert-${message.type}`}>
                        <span className="alert-icon">
                            {message.type === 'success' ? '✅' : '❌'}
                        </span>
                        <span className="alert-text">{message.text}</span>
                    </div>
                )}

                {loading ? (
                    <div className="switcher-loading">
                        <div className="spinner"></div>
                        <p>Загрузка кабинетов...</p>
                    </div>
                ) : accounts.length === 0 ? (
                    <div className="empty-state">
                        <p>У вас нет добавленных VK кабинетов.</p>
                        <p>Добавьте кабинет в настройках.</p>
                    </div>
                ) : (
                    <div className="accounts-grid">
                        {accounts.map(account => (
                            <div 
                                key={account.id} 
                                className={`account-card ${account.is_default ? 'active-account' : ''} ${!account.is_active ? 'inactive-account' : ''}`}
                                onClick={() => !account.is_default && account.is_active && handleSwitchAccount(account.id)}
                            >
                                <div className="card-content">
                                    <h3>{account.account_name}</h3>
                                    <p className="company-name">{account.company_name || 'Компания не указана'}</p>
                                </div>
                                <div className="card-footer">
                                    {account.is_default && (
                                        <span className="status-badge active">
                                            <span className="badge-icon">✓</span> Активный
                                        </span>
                                    )}
                                    {!account.is_active && (
                                        <span className="status-badge inactive">
                                            <span className="badge-icon">✗</span> Неактивен
                                        </span>
                                    )}
                                    {!account.is_default && account.is_active && (
                                        <button 
                                            className="btn btn-sm btn-switch" 
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleSwitchAccount(account.id);
                                            }}
                                            disabled={switchingAccountId === account.id}
                                        >
                                            {switchingAccountId === account.id ? 'Переключение...' : '↻ Переключить'}
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
                
                <button className="btn btn-secondary close-bottom-btn" onClick={onClose}>Закрыть</button>
            </div>
        </div>
    );
};

export default VKAccountSwitcher;

